// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"665":"5175b93c","902":"389ab270"}[chunkId] + ".chunk.css";
};